import { Grid } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { FC, Fragment, useContext } from 'react';
import { PageTitle } from '../page-title';
import { ExternalLinkPortalCard, LinkPortalCard } from '../portal-layout';
import { Page } from './Page';
import { useFlags } from '../../hooks';
import { UserContext } from '../../context';
import { INavLink } from '../../models';
import { isLenderOrAttorney } from '../../helpers';

interface ILanding {
  title: string;
  selectedTab: string;
  setSelectedTab: (val: string) => void;
  landingLinks: INavLink[];
}

export const Landing: FC<ILanding> = ({
  title,
  selectedTab,
  setSelectedTab,
  landingLinks = []
}) => {
  const classes = useStyles();
  const featureFlags = useFlags();
  const userContext = useContext(UserContext);

  const filteredLandingLinks = isLenderOrAttorney(userContext?.user)
    ? landingLinks.filter(link => link?.id === 'build-documentation')
    : landingLinks;

  return (
    <Page title={title} showSideBar={false} sideBarLinks={[]}>
      <PageTitle title={title} />
      <Grid spacing={2} container alignItems="center" className={classes.wrapper}>
        {filteredLandingLinks?.map((link, i) => {
          const hasLegacyLink =
            (link.legacyUrl && !link.url) || link?.legacyUrl === link?.url ? true : false;
          const hasLegacyLinkWithFFOff =
            link.featureFlag && link.legacyUrl && !featureFlags[link.featureFlag] ? true : false;
          return (
            <Fragment key={`${i}`}>
              <Grid xs={12} sm={6} md={4} item>
                {hasLegacyLink || hasLegacyLinkWithFFOff ? (
                  <ExternalLinkPortalCard link={link} />
                ) : (
                  <LinkPortalCard link={link} />
                )}
              </Grid>
            </Fragment>
          );
        })}
      </Grid>
    </Page>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    marginTop: '0',
    paddingBottom: '1rem'
  },
  tabBar: {
    backgroundColor: '#fff',
    boxShadow: 'none',
    borderBottom: `1px solid ${theme.palette.grey[400]}`
  }
}));
